export default "__VITE_ASSET__BGZkK6$V__"